import api from './api';

export default {
  getCategories() {
    return new Promise((resolve, reject) => {
      api
        .get('category', {
          params: {
            orderby: 'sort_order,asc'
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
